import { render, staticRenderFns } from "./PeStatus.vue?vue&type=template&id=2a63f3c0&"
import script from "./PeStatus.vue?vue&type=script&lang=js&"
export * from "./PeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports